<template>
<nav class="navbar header-navbar pcoded-header">
    <div class="navbar-wrapper w-100">
        <div class="navbar-logo">
            <a class="mobile-menu" id="mobile-collapse" href="#">
                <i class="feather icon-menu"></i>
            </a>
            <router-link :to="{ name: 'index' , params: { search: 'null' }}" exact>
                <img class="img-fluid img-logo" :src="$url('images/logo.png')" alt="THEVIRUS MANAGE">
            </router-link>
            <a class="mobile-options">
                <i class="feather icon-more-horizontal"></i>
            </a>
        </div>

        <div class="navbar-container">
            <ul class="nav-left">
                <li class="header-search">
                    <div class="main-search morphsearch-search">
                        <div class="input-group">
                            <span class="input-group-addon search-close"><i class="feather icon-x"></i></span>
                            <input type="text" class="form-control">
                            <span class="input-group-addon search-btn"><i class="feather icon-search"></i></span>
                        </div>
                    </div>
                </li>
                <li>
                    <a href="#" @click="toggleFullScreen">
                        <i class="feather icon-maximize full-screen"></i>
                    </a>
                </li>
            </ul>
            <ul class="nav-right">
                <!-- <li class="header-notification">
                    <div class="dropdown-primary dropdown">
                        <div class="dropdown-toggle" data-toggle="dropdown">
                            <i class="feather icon-bell"></i>
                            <span class="badge bg-c-pink">5</span>
                        </div>
                        <ul class="show-notification notification-view dropdown-menu" data-dropdown-in="fadeIn" data-dropdown-out="fadeOut">
                            <li>
                                <h6>Notifications</h6>
                                <label class="label label-danger">New</label>
                            </li>
                            <li>
                                <div class="media">
                                    <img class="d-flex align-self-center img-radius" :src="$url('files/assets/images/avatar-4.jpg')" alt="Generic placeholder image">
                                    <div class="media-body">
                                        <h5 class="notification-user">John Doe</h5>
                                        <p class="notification-msg">Lorem ipsum dolor sit amet, consectetuer elit.</p>
                                        <span class="notification-time">30 minutes ago</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="media">
                                    <img class="d-flex align-self-center img-radius" :src="$url('files/assets/images/avatar-3.jpg')" alt="Generic placeholder image">
                                    <div class="media-body">
                                        <h5 class="notification-user">Joseph William</h5>
                                        <p class="notification-msg">Lorem ipsum dolor sit amet, consectetuer elit.</p>
                                        <span class="notification-time">30 minutes ago</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="media">
                                    <img class="d-flex align-self-center img-radius" :src="$url('files/assets/images/avatar-4.jpg')" alt="Generic placeholder image">
                                    <div class="media-body">
                                        <h5 class="notification-user">Sara Soudein</h5>
                                        <p class="notification-msg">Lorem ipsum dolor sit amet, consectetuer elit.</p>
                                        <span class="notification-time">30 minutes ago</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li> -->
                <li class="user-profile header-notification">
                    <div class="dropdown-primary dropdown">
                        <div class="dropdown-toggle" data-toggle="dropdown">

                            <img :src="$url('images/icon-thevirus.png')" class="img-radius" alt="User-Profile-Image">
                            <span>{{ username }}</span>
                            <i class="feather icon-chevron-down"></i>
                        </div>
                        <ul class="show-notification profile-notification dropdown-menu" data-dropdown-in="fadeIn" data-dropdown-out="fadeOut">
                            <!-- <li>
                                <a href="#!">
                                    <i class="feather icon-settings"></i> Settings
                                </a>
                            </li> -->
                            <li>
                                <a href="#">
                                    <i class="feather icon-user"></i> Profile
                                </a>
                            </li>
                            <!-- <li>
                                <a href="email-inbox.htm">
                                    <i class="feather icon-mail"></i> My Messages
                                </a>
                            </li>
                            <li>
                                <a href="auth-lock-screen.htm">
                                    <i class="feather icon-lock"></i> Lock Screen
                                </a>
                            </li> -->
                            <li v-if="loggedIn" @click.stop.prevent="logout">
                                <a href="#">
                                    <i class="feather icon-log-out"></i> Logout
                                </a>
                            </li>
                        </ul>

                    </div>
                </li>
            </ul>
        </div>
    </div>
</nav>
</template>

<script>

import {logout, isLoggedIn, getUser} from '@/services/auth-service';

export default {
    data () {
        return {
            loggedIn: false,
            username: null
        };
    },
    created () {
        this.loggedIn = isLoggedIn();
        if(this.loggedIn) {
            getUser().then(res => {
                this.username = res.data.name
            });
        }
    },
    mounted () {
    },
    methods: {
        logout: function() {
            logout()
            .then(res => {
            }).catch(err => {
                this.$fire({
                    text: 'Some error occurred, Please try again',
                    type: 'error'
                });
            }).then(() => {
                localStorage.removeItem('vue-token');
                this.$router.push({name: 'login'});
                this.submit_loader = false;
            });
        },
        toggleFullScreen: function() {
            var a = $(window).height() - 10;
            if (!document.fullscreenElement && // alternative standard method
                !document.mozFullScreenElement && !document.webkitFullscreenElement) { // current working methods
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
            $('.full-screen').toggleClass('icon-maximize');
            $('.full-screen').toggleClass('icon-minimize');
        }
    }
};
</script>

<style scoped >
.main-search .form-control {
    flex: 1 1 auto;
}
.img-logo {
    height: 40px;
}
</style>
